import { render, staticRenderFns } from "./GeneralInquiry.vue?vue&type=template&id=579a5998&scoped=true&"
import script from "./GeneralInquiry.vue?vue&type=script&lang=js&"
export * from "./GeneralInquiry.vue?vue&type=script&lang=js&"
import style0 from "./GeneralInquiry.vue?vue&type=style&index=0&id=579a5998&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579a5998",
  null
  
)

export default component.exports